import { useService } from 'composables/useService/useService';
import { importMappingServiceKey } from './keys/import-mapping.keys';
import { RetailerImportMappingViewService } from './import-mapping.view.service';

export function useRetailerImportMappingService(): RetailerImportMappingViewService {
  return useService(importMappingServiceKey, RetailerImportMappingViewService);
}
